import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/api.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip adding token for auth-related endpoints
  const excludedEndpoints = [
    '/user/login',
    '/user/registration', 
    '/user/otp',
    '/portal'
  ];

  const isExcluded = excludedEndpoints.some(endpoint => 
    req.url.includes(endpoint)
  );

  // Debug: trace scenario request
  if (req.url.includes('/scenario')) {
    console.log('[HTTP] Scenario request', req.method, req.url);
  }

  if (isExcluded) {
    return next(req);
  }

  const token = AuthService.getAccessToken();

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        'X-Access-Token': token
      }
    });
    if (authReq.url.includes('/scenario')) {
      console.log('[HTTP] Scenario request with auth header');
    }
    return next(authReq);
  }

  return next(req);
}; 